import React, {Component} from "react";
import {withStyles} from "@material-ui/core/styles";
import {
    CircularProgress
} from "@material-ui/core";
import TrnCharts from "./transactionCharts";
import CountWidget from "./countWidget";
import * as PropTypes from "prop-types";

const styles = theme => ({
    chartContainer: {
        marginLeft: -22,
    },
    tableContainer: {
        height: 320,
    },
    card1: {
        position:"absolute",
        maxWidth: 345,
        top:"50px",
        left:"50px"
    },
    card2: {
        maxWidth: 345,
    },
    media: {
        height: 140,
        position:"relative",
        bottom:"150px",
        left:"150px"
    },
    chartTitle: {
        textAlign: "center"
    }   
});


class dashboard extends Component {
    
    // constructor(props){
    //     super(props);
    // }

    componentDidMount(){
        this.props.getDashboardWidgetData();
    }

    render() {
        const { classes } = this.props;
        const { isLoading, userCount, merchantCount, trnChart, ipg } = this.props.dashboard;

        return (
            <div>
                {isLoading ? <CircularProgress size={20} className={classes.progress} />
                    :
                    <div>
                        <CountWidget uCount={userCount} mCount={merchantCount} ipgTot={ipg.total} ipgCom={ipg.commTotal} />
                        <TrnCharts monthChart={trnChart} />
                    </div>
                }
            </div>      
        );
    }

    static get propTypes() {
        return {
            getDashboardWidgetData: PropTypes.func,
            dashboard: PropTypes.any,
            classes: PropTypes.any
        };
    }
}


export default withStyles(styles)(dashboard);
